import React, {Component} from 'react';

import styles from '../../../static/css/articleStyleModules/articleBase.module.scss';

import { CSSTransition } from 'react-transition-group';

import IntroArticle from './IntroArticle';
import A2HSHelpArticle from './A2HSHelpArticle';
import TutorialArticle from './TutorialArticle';

export default class ArticleBase extends Component {

    constructor(props){
        super(props);
        this.state = {
            // page:0,

            // lastPage:1,
        }
    }

    // componentWillMount = () => {
    //     this.articleSetUp();
    // }

    // articleSetUp = () => {
    //     if(this.props.articleMode === 'help'){
    //         this.setState({
    //             lastPage:1,
    //         })
    //     }else if(this.props.articleMode === 'tutorial'){
    //         this.setState({
    //             lastPage:4,
    //         })
    //     }
    // }

    // goToPrevPage = () => {
    //     if(this.state.page === 0){
    //         return
    //     }else{
    //         const prevPage = this.state.page - 1;
    //         this.setState({page:prevPage})

    //         process.nextTick(() => {
    //             this.refs.mainArea.scrollTop = 0;
    //         })

    //     }
    // }

    // goToNextPage = () => {
    //     if(this.state.page >= this.state.lastPage ){
    //         return
    //     }else{
    //         const nextPage = this.state.page + 1;
    //         this.setState({page:nextPage});

    //         process.nextTick(() => {
    //             this.refs.mainArea.scrollTop = 0;
    //         })
    //     }
    // }

    backgroundClick = () => {
        if(this.props.singleHelp){
            this.props.onBackgroundClick();
        }
    }

    render() {
        
        return (
            <div className={styles['articleArea']}
            onClick={this.backgroundClick}>
              <div className={styles['articleBaseArea']}>
                <CSSTransition
                in={this.props.articleMode === 'introduction'}
                timeout={200}
                classNames="simpleFadeIn200"
                unmountOnExit
                mountOnEnter
                >
                  <IntroArticle 
                  onChangeArticle={(articleMode) => this.props.onChangeArticle(articleMode)}
                  />
                </CSSTransition>

                <CSSTransition
                in={this.props.articleMode === 'A2HSHelp'}
                timeout={200}
                classNames="simpleFadeIn200"
                unmountOnExit
                mountOnEnter
                >
                  <A2HSHelpArticle 
                  singleHelp={this.props.singleHelp}
                  onChangeArticle={(articleMode) => this.props.onChangeArticle(articleMode)}
                  onCloseButtonClick={() => this.backgroundClick}
                  />
                </CSSTransition>
                <CSSTransition
                in={this.props.articleMode === 'tutorial'}
                timeout={200}
                classNames="simpleFadeIn200"
                unmountOnExit
                mountOnEnter
                >
                  <TutorialArticle
                  onInfoDispShow={this.props.onInfoDispShow}
                  onEndTutorial={this.props.onCloseTutorial}
                  />
                </CSSTransition>
              </div>
            </div>
        )
    }

};

ArticleBase.defaultProps = {
    articleMode:'introduction',
}